import React from 'react'

import './footer_product_menu.scss'

export default () => {
  return (
    <div className="footer-product-menu">
      <ul>
        <li>
          <a href="/products/all">
            Shop Products
          </a>
        </li>
        <li>
          <a href="/products/livestock-handling">
            Livestock Handling
          </a>
        </li>
        <li>
          <a href="/products/fencing">
            Fencing
          </a>
        </li>
        <li>
          <a href="/products/tubular-steel">
            Tubular Steel
          </a>
        </li>
        <li>
          <a href="/products/structural-merchant-bar">
            Structural & Merchant Bar
          </a>
        </li>
        <li>
          <a href="/products/other">
            Other
          </a>
        </li>
      </ul>
    </div>
  )
}